import React, { useState } from 'react';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Tooltip,
  Typography,
} from '@mui/material';
import { LegalPhaseRow } from './LegalPhaseRow';
import { FullScreenDialog } from '../../core/FullScreenDialog';
import { LegalPhaseTableEdit } from './Edit/LegalPhaseTableEdit';
import { ILegalRequirementState } from '../../Interfaces/ILegalRequirementState';
import { IDocumentDownloaded } from '../../Interfaces/IDocumentDownloaded';
import {
  useAdministrativeUnits,
  useCourtCourtRoles,
  useFederalStates,
} from '../../Aemter/hooks';

interface IProps {
  legalPhaseFullObjectArray: ILegalPhaseFullObject[];
  setLegalPhaseFullObjectArray: Function;
  legalReqState: ILegalRequirementState[];
  downloadedArray?: IDocumentDownloaded[];
  legaltransactionId: number;
  startdatedeadline: Date | undefined;
}

export const LegalPhaseMain: React.FC<IProps> = ({
  legalPhaseFullObjectArray,
  legalReqState,
  legaltransactionId,
  setLegalPhaseFullObjectArray,
  startdatedeadline,
  downloadedArray,
}) => {
  // useStates
  const [legalPhaseEditArray, setLegalPhaseEditArray] = useState([
    ...legalPhaseFullObjectArray,
  ]);
  const [isOpenEditDialog, setIsOpenEditDialog] = useState(false);
  // React-Query
  const { administrativeUnits, isLoadingAdministrativeUnits } =
    useAdministrativeUnits();
  const { federalStates, isLoadingFederalStates } = useFederalStates();
  const { courtCourtRoles, isLoadingCourtCourtRoles } = useCourtCourtRoles();
  //
  const handleOpenEdit = () => {
    setLegalPhaseEditArray([...legalPhaseFullObjectArray]);
    setIsOpenEditDialog(true);
  };

  if (
    isLoadingAdministrativeUnits ||
    isLoadingFederalStates ||
    isLoadingCourtCourtRoles
  ) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          height: '20vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!administrativeUnits || !federalStates || !courtCourtRoles) {
    return (
      <Box
        sx={{
          m: 2,
        }}
      >
        <Typography>Fehler beim Laden der Daten</Typography>
      </Box>
    );
  }

  return (
    <>
      <FullScreenDialog
        isOpen={isOpenEditDialog}
        onClose={() => setIsOpenEditDialog(false)}
        title='Rechtsgeschäftsart'
        disablePadding={true}
      >
        <LegalPhaseTableEdit
          legalPhaseArray={legalPhaseEditArray}
          setLegalPhaseArray={setLegalPhaseEditArray}
          setLegalPhaseFullObjectArray={setLegalPhaseFullObjectArray}
          setIsOpenEditDialog={setIsOpenEditDialog}
          adminUnitArray={administrativeUnits}
          federalStateArray={federalStates}
          courtcourtroleArray={courtCourtRoles}
          legaltransactionId={legaltransactionId}
        />
      </FullScreenDialog>

      <Typography variant='h5' sx={{ mb: 3 }}>
        Aktueller Statusverlauf
        <Tooltip title='Maßnahmen und Phasen anpassen'>
          <Button
            sx={{ float: 'right' }}
            onClick={handleOpenEdit}
            variant='outlined'
          >
            Anpassen
          </Button>
        </Tooltip>
      </Typography>

      <Grid container spacing={1}>
        {legalPhaseFullObjectArray
          .sort((a, b) => (a.Position < b.Position ? -1 : 1))
          .map(x => (
            <LegalPhaseRow
              key={`idLegalPhase-${x.idLegalPhase}-${x.LegalRequirementArray.length}`}
              legalPhaseFullObject={x}
              legalPhaseFullObjectArray={legalPhaseFullObjectArray}
              setLegalPhaseFullObjectArray={setLegalPhaseFullObjectArray}
              legalReqState={legalReqState}
              downloadedArray={downloadedArray}
              startdatedeadline={startdatedeadline}
            />
          ))}
      </Grid>
    </>
  );
};
